/* eslint-disable react/no-array-index-key */
import React from 'react';

const StatusPayment = (props) => (
    <React.Fragment>
        {props.purchase.payment_method !== "PIX" ?
            <div className="title-box">
                Pagamento
            </div> : null}

        <div className="box payment">
            <div className={`header-box ${props.theme}`}>
                {props.purchase.payment_method === "PIX" ?
                    <div className={`payment-method ${props.purchase.payment_method}`}> Instruções para pagamento <b>via {props.purchase.payment_method}</b> </div> : ""
                }
            </div>
            <div className="body-box">
                {props.children}
            </div>
        </div>
    </React.Fragment>
)

export default StatusPayment;



// WEBPACK FOOTER //
// ./src/components/purchase_status/StatusPayment.jsx